<template>
	<li class="item">
		<a v-bind:href="result.Url" v-bind:title="result.Name" target="_blank">
			<span>{{ result.Name }}</span>
			<span>{{ formatDate(result.PublishDate) }}</span>
		</a>
	</li>
</template>


<script>
	import DateFormatService from '../../common/date-format.service';

    export default {
	props: {
			result: {
				type: Object,
				default: () => {}
			},
		},

	data: function() {
		return  {

		}
	},
	methods: {
		formatDate: function (date) {
			return DateFormatService.customFormatter(date, 'full-slash');
			}
	}
}
</script>